<template>
  <div class="scanCode_info">
    <div class="score_header" v-if="ticketNum !== ''">
      <div class="return__icon" @click="returnBack">
        <i class="iconfont icon_lulufanhui"></i>
      </div>
      <div class="title">扫码结果</div>
    </div>
    <div class="scanCode_second">{{ ticketNum }}</div>
  </div>
</template>

<script>
import {post} from "../../network/Interface";
import wx from 'weixin-js-sdk'
// import {Toast} from "vant";

export default {
  name: "scanCodePage",
  data() {
    return {
      ticketNum: '',
      configContent: [],
      // BASE_URL: ""
    }
  },
  mounted() {
    this.getSign();
    // this.BASE_URL = Vue.prototype.BASE.BASE_URL
  },
  watch: {},
  methods: {
    returnBack() {
      this.$router.push('/')
    },
    async getSign() {
      let url = "";
      if (navigator.userAgent.indexOf("iPhone") !== -1) {
        url = window.sessionStorage.getItem("EntryUrl");
      } else {
        const {href} = window.location;
        url = href.split("#")[0];
      }
      const data = {
        url, //url不能写死
      };
      const divI = document.getElementsByClassName('scanCode_info')[0] // 后续修改的样式，可以不用
      divI.style.backgroundColor = '#9c9c9c'
      this.configContent = await post("wx/wechatSignature", data);
      this.signWX()
      // post("wx/wechatSignature", data).then(res => {
      //   if (res.status === 200) {
      //     this.configContent = res.data  // 接口返回的数据，用于下面的配置
      //     this.signWX()
      //   }
      // })
    },
    signWX() {
      let _this = this
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: _this.configContent.data.appId, // 必填，公众号的唯一标识
        timestamp: _this.configContent.data.timestamp, // 必填，生成签名的时间戳
        nonceStr: _this.configContent.data.nonceStr, // 必填，生成签名的随机串
        signature: _this.configContent.data.signature, // 必填，签名
        jsApiList: ["scanQRCode", "checkJsApi"] // 必填，需要使用的JS接口列表
      })
      wx.ready(function () {
        const divI = document.getElementsByClassName('scanCode_info')[0]
        divI.style.backgroundColor = ''
        // wx.checkJsApi({
        //   jsApiList:['scanQRCode'],
        //   success:function (res){
        //     if (res.checkResult.scanQRCode === true){}
        //   }
        // })
        wx.scanQRCode({
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
          success: function (res) {
            _this.ticketNum = res.resultStr // 当needResult 为 1 时，扫码返回的结果
            window.location.replace(_this.ticketNum);

          },
          cancel: function () {
            _this.$router.go(-1);
          }
        })
      })
      wx.error(function (res) {
        const divI = document.getElementsByClassName('scanCode_info')[0]
        divI.style.backgroundColor = ''
        alert('微信js-sdk配置失败' + res.errMsg)
      })
    }
  },
}
</script>

<style scoped lang="less">
.scanCode_info {
  height: 100%;
  position: relative;
}

.score_header {
  font-size: 16px;
  width: 100%;
  background-color: #42b983;
  color: #fff;
  line-height: 40px;
  flex: none;
  z-index: 1;
}

.return__icon {
  margin-left: 20px;
  width: 20px;
  height: 20px;
  position: absolute;
}

.iconfont {
  margin-top: 10px;
  font-size: 20px;
}

.title {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.scanCode_second {
  margin-top: 18%;
  text-align: center;
  color: #3c3c3c;
}
</style>